import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"textInput":"styles_textInput__4PEfG","input":"styles_input__CGLHl","textarea":"styles_textarea__5GSyG","mock":"styles_mock__o8Ob3","hidden":"styles_hidden__O7S1s"};
export const b = b_.with('textInput');